/* istanbul ignore file */

export enum FieldStyleColor {
    Red = 1,
    Orange = 2,
    Yellow = 3,
    Green = 4,
    Blue = 5,
    Purple = 6,
    NoColor = 7,
}

export enum FieldStyleColorName {
    Red = "red",
    Orange = "orange",
    Yellow = "yellow",
    Green = "green",
    Blue = "blue",
    Purple = "purple",
    NoColor = "no color (default)",
}
